/* eslint-disable object-curly-newline */
/* eslint-disable quotes */
/* eslint-disable indent */
import React, { useEffect, useRef, useState } from 'react';
import './Telegram.scss';
import { useDispatch, useSelector } from 'react-redux';
import { getAccountsStart } from 'store/actions';
import SelectDepositMethodModal from 'components/Modals/Deposits/SelectDepositMethodModal';

const Telegram = () => {
    const iframeRef = useRef(null);
    const dispatch = useDispatch();

    const { accounts } = useSelector((state) => state.forex.accounts);
    const [flag, setFlag] = useState(false);

    const [openModal, setOpenModal] = useState(false);

    const liveAccounts = accounts?.filter(account => account.accountTypeId.type === 'LIVE');

    useEffect(() => {
        dispatch(getAccountsStart({ type: 'LIVE' }));
    }, [dispatch]);

    useEffect(() => {
        if (liveAccounts?.length > 0) {
            const hasEnoughBalance = liveAccounts.some(account => parseFloat(account.Balance) >= 100);
            setFlag(hasEnoughBalance);
        }
    }, [accounts]);

    const accountNumber = accounts?.[0]?.login;
    const server = 'MarketsAct-server';
    const platform = 'mt5';

    const iframeSrc = `https://api.tradingbull.ai/telegram?accountnumber=${accountNumber}&server=${server}&platfrom=${platform}&token=deb559d4-f9bb-4c12-b0df-a7d6d0a15a0e&c=marketact`;

    return (
    <div className="telegram-bot-page">
      {/* Overlay shown when flag is false */}
      {!flag && (
        <div className="overlay">
          <div className="overlay-content">
            <p>You must have a LIVE account with a balance of at least $100 to access this feature.</p>
            <button onClick={() => setOpenModal(true)}>
              Deposit Now
            </button>
          </div>
        </div>
      )}

      {/* QR Code iframe */}
      <p className="description">
  Scan the <strong>QR code</strong> to unlock the <span style={{ color: '#007bff' }}>TradingBull Telegram Bot</span>:<br />
  Get real-time signals and alerts, in your language, customized to what matters most to you.
   </p>
      <iframe
        ref={iframeRef}
        id="QRForm"
        src={iframeSrc}
        title="Telegram QR Bot"
      />

      <SelectDepositMethodModal
        isOpen={openModal}
        toggleOpen={() => {
            setOpenModal(!openModal);
          }}
      />
    </div>
  );
};

export default Telegram;